import PQAPI from '~/plugins/pqapi/pqapi';

export default (context, inject) => {
  inject('pqapi', new PQAPI(context.$config));
}